// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// components
import { BudgetListComponent } from 'app/budgets/budget-list/budget-list.component';
import { BudgetComponent } from 'app/budgets/budget/budget.component';

// modules
import { MaterialModule } from 'app/shared/material/material.module';
import { ComponentsModule } from 'app/shared/components/components.module';

// services
import { BudgetService } from 'app/budgets/shared/budget.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    ComponentsModule,
    TranslateModule,
    PdfJsViewerModule,
  ],
  exports: [
    BudgetListComponent,
    BudgetComponent
  ],
  declarations: [
    BudgetListComponent,
    BudgetComponent
  ],
  providers: [
    BudgetService
  ]
})
export class BudgetsModule { }



// WEBPACK FOOTER //
// ./src/app/budgets/budgets.module.ts